import { ConstrainedItem } from './constrained-object';

export interface SelectedElement extends SelectedItem {
  parents: SelectedItem[];

  constrained: ConstrainedItem;

  armyListUnitIds: string[];

  count: number;
  quantity: number;
  points: number;
}

export interface SelectedItem {
  type: SelectedItemType;
  id: string | number;

  name: string;
}

export enum SelectedItemType {
  ArmyList = 'Builder::ArmyList',
  ArmyListUnit = 'Builder::ArmyListUnit',
  ArmyListUnitOption = 'Builder::ArmyListUnitOption',
  ArmyListUnitOptionGroup = 'Builder::ArmyListUnitOptionGroup',
  ArmyListUnitTroop = 'Builder::ArmyListUnitTroop',
  ArmyOrganisation = 'NinthAge::ArmyOrganisation',
  ArmyListUnitOrganisation = 'Builder::ArmyListUnitOrganisation',
}
